import { Outlet } from 'react-router-dom';
import Logo from '../assets/images/logo.svg';
import AppToast from '../components/common/Toast';
import { useAppContext } from '../utils/context/app-context';

const AuthLayout = () => {
  const { toastInfo } = useAppContext();
  return (
    <div className="flex items-center justify-center p-5 w-full h-full flex-col">
      <div className="flex justify-center items-center mb-5">
        <img src={Logo} className='w-[50px] h-[50px]' alt="logo" />
        <span className='font-semibold sm:text-[50px] ml-6'>Answerr</span>
      </div>
      <Outlet />

      {toastInfo?.isOpen && <AppToast />}
    </div>
  );
};

export default AuthLayout;
